var render = function render(){var _vm=this,_c=_vm._self._c;return _c('type-template',{attrs:{"spot-occurrence-values":_vm.spotOccurrenceValues,"spot-shapes":_vm.spotShapes,"first-spots-occurrence":_vm.firstSpotsOccurrence,"field-errors":_vm.fieldErrors},on:{"field-change":_vm.onFieldChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }